window.Vue = require('vue');

Vue.component('questions', require('./Questions.vue'));
Vue.component('survey-question-rules-wrapper', require('./SurveyQuestionRulesWrapper.vue'));




// WEBPACK FOOTER //
// ./resources/js/app/components/vue-declarator.js